import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css"; // Aktualisiertes Styling

const Navbar = () => {
  const [isTftDropdownOpen, setIsTftDropdownOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="nav-title">Poke-Meta</Link>
      

      <div className="navbar-links">
        {/* 📌 TFT mit Dropdown-Menü */}
        <div 
          className="nav-dropdown"
          onMouseEnter={() => setIsTftDropdownOpen(true)}
          onMouseLeave={() => setIsTftDropdownOpen(false)}
        >
          <button className="nav-button">TFT</button>
          {isTftDropdownOpen && (
            <div className="dropdown-menu">
        
              <li className="nav-item"><a href="/news" className="nav-link">
                  <span className="led-text">NEWS</span>
                </a>
              </li>
              <Link to="/pokemons" className="dropdown-item">Pokémons</Link>
              <Link to="/synergy" className="dropdown-item">Synergy</Link>
              <Link to="/helditems" className="dropdown-item">Helditems</Link>
              <Link to="/teamcomps" className="dropdown-item">Teamcomps</Link>
              <Link to="/teambuilder" className="dropdown-item">Teambuilder</Link>
              <Link to="/teamComm" className="dropdown-item">Comm. Teams</Link>
             
              <Link to="/howto" className="dropdown-item">How to play!</Link>
              <Link to="/impressum" className="dropdown-item">Impressum</Link>
              
            </div>
            
          )}
        </div>
        </div>

        {/* Direktlink zu Arceus 
        <Link to="/arceus" className="nav-link">Arceus</Link>*/}
      </div>
    </nav>
  );
};

export default Navbar;

//{!localStorage.getItem("token") ? (
  // <Link to="/login">Login</Link>  ) : (<>
  //</> <Link to="/admindashboard">Admin</Link> 
   //</>
//)}